import React from 'react'
import Our_presence from '../home/our_presence/Our_presence'
import About_us_banner from './about_us_banner/About_us_banner'
import About_us_content from './about_us_content/About_us_content'
import About_vission_mission from './about_vission_mission/About_vission_mission'
import About_why_choose_us from './about_why_choose_us/About_why_choose_us'
import About_Key_to_success from './about_Key_to_success/About_Key_to_success'

function About_us() {
    return (
        <>

            <About_us_banner />
            <About_us_content />
            <About_vission_mission />
            <About_Key_to_success />
            <Our_presence />
            <About_why_choose_us />
        </>
    )
}

export default About_us